import { useRef, useEffect } from 'react';
import useGame from "../stores/useGame";
import Countdown, { zeroPad } from "react-countdown";

export default function MadnessTrigger() {

    // Refs
    const showCountdownRef = useRef()
    const countdown = useRef()

    // State
    const showCountdown = useGame((state)=> {return state.showCountdown})
    const setCountdownEnded = useGame((state)=>{return state.setCountdownEnded})
    const portalEntered = useGame((state)=>{return state.portalEntered})

    // Custom Countdown renderer
    const countdownRenderer = ({ seconds }) => (
        <span>
            {zeroPad(seconds)}
        </span>
        );

    // Message fadeout
    useEffect(() => {
    if (showCountdown) {
        // Apply fadeout class after 2s
        const timeoutId = setTimeout(() => {
        showCountdownRef.current.classList.add("fade-out");
        }, 2500);

        // Cleanup setTimeout
        return () => {
        clearTimeout(timeoutId);
        showCountdownRef.current.classList.remove("fade-out");
        };
    }
    }, [showCountdown]);

    return <>
        <div className='escape-container'>
            <h1 ref={showCountdownRef} className={`player-message`}>Endless steps, finite time. 30 seconds to find the exit.</h1>
            {!portalEntered && <Countdown
            ref={countdown}
            date={Date.now() + 29000}
            zeroPadTime={1}
            precision={0}
            renderer={countdownRenderer}
            onComplete={setCountdownEnded}
            controlled={false}
            ></Countdown >}
        </div>
    </>
}
